import Input from 'components/Form/Input'
import { Search } from 'components/Icons/components'
import { Close } from 'components/Icons/components'
import withCondition from 'components/withCondition'
import styled from 'styled-components'
import { btnSecondaryBg, grayLighter, media, transition, white } from 'utils/style-utils'

interface Props {
  isActive: boolean
}

export const Box = styled.div.withConfig({
  shouldForwardProp: (prop) => !prop.includes('isActive'),
})<Props>`
  position: relative;
  height: 2.5rem;
  max-width: 15rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  user-select: none;

  ${transition('width', 0.5)}

  ${media.sm`
    ${(props: Props) => (props.isActive ? 'width: 100%' : `width: 2rem; overflow: hidden;`)};
  `}
`

export const SearchIconsContainer = styled.label`
  position: absolute;
  height: 100%;
  left: 0.5rem;
  top: 0rem;
  display: flex;
  align-items: center;

  cursor: pointer;
`

interface Props {
  isActive: boolean
}
export const StyledSearchIcon = styled(Search).withConfig({
  shouldForwardProp: (prop) => !prop.includes('isActive'),
})<Props>`
  z-index: 1;
  height: 1.25rem;
  user-select: none;

  ${({ isActive }: Props) => (isActive ? `fill: ${btnSecondaryBg}` : `fill: ${white}`)};
`

export const StyledInput = styled(Input)`
  height: 100%;
  padding: 0 0 0 2.25rem;
  z-index: 0;

  ${media.sm`
    &[value=""] {
      opacity: 0;
    }
  `}

  ${transition('opacity', 0.5)}

  :focus {
    opacity: 1;

    &::placeholder {
      opacity: 0;
    }
  }
`

export const StyledCloseIcon = withCondition(styled(Close).withConfig({
  shouldForwardProp: (prop) => !prop.includes('isActive'),
})`
  z-index: 1;
  position: absolute;
  height: 1rem;
  top: 50%;
  right: 0.75rem;
  transform: translateY(-50%);
  fill: ${grayLighter};

  cursor: pointer;
`)
